﻿import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Box,
  IconButton,
  Typography,
  CircularProgress,
} from "@mui/material";
import { CloseIconFill } from "@/ImageRepo";
import "./ViewDataPopup.css";
import ShepButton from "../../GenericComponents/ShepButton";
import { ShepTab, ShepTabs } from "../../GenericComponents/ShepTab";

import {
  setViewDataPopupOpen,
  selectViewDataPopupOpen,
  selectViewDataPopupData,
} from "@/features/homepage/homeSlice";

const ViewDataPopup = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();
  const open = useSelector(selectViewDataPopupOpen);
  const {
    rawDataSource = "Nothing to Display",
    structuredDataSource = "Nothing to Display",
    rawDataTarget = "Nothing to Display",
    structuredDataTarget = "Nothing to Display",
    catalogData = "Nothing to Display",
  } = useSelector(selectViewDataPopupData);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCloseViewDataPopup = () => {
    dispatch(setViewDataPopupOpen(false));
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseViewDataPopup}
      fullWidth
      maxWidth="md"
      PaperProps={{
        className: "view-data-popup",
        style: {
          position: "absolute",
          bottom: 0,
          transform: "translateY(-10%)",
        },
      }}
      sx={{ zIndex: "1500" }}
    >
      <DialogTitle className="view-data-popup-header">
        <Typography variant="h4">View Data</Typography>
        <IconButton className="close-button" onClick={handleCloseViewDataPopup}>
          <CloseIconFill className="view-data-close-icon" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ShepTabs
          variant="viewData"
          value={activeTab}
          onChange={handleTabChange}
          aria-label="data tabs"
          className="view-data-popup-tabs"
        >
          <ShepTab variant="viewData" label="Structured Data (Source)" />
          <ShepTab variant="viewData" label="Raw Data (Source)" />
          <ShepTab variant="viewData" label="Structured Data (Target)" />
          <ShepTab variant="viewData" label="Raw Data (Target)" />
          <ShepTab variant="viewData" label="Catalog Data" />
        </ShepTabs>
        <Box className="tab-content">
          {structuredDataSource === "default" &&
          rawDataSource === "default" &&
          structuredDataTarget === "default" &&
          rawDataTarget === "default" ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {activeTab === 0 && (
                <Box component="pre" className="data-box">
                  {JSON.stringify(structuredDataSource, null, 2)}
                </Box>
              )}
              {activeTab === 1 && (
                <Box component="pre" className="data-box">
                  {rawDataSource}
                </Box>
              )}
              {activeTab === 2 && (
                <Box component="pre" className="data-box">
                  {JSON.stringify(structuredDataTarget, null, 2)}
                </Box>
              )}
              {activeTab === 3 && (
                <Box component="pre" className="data-box">
                  {rawDataTarget}
                </Box>
              )}
              {activeTab === 4 && (
                <Box className="data-box">
                  <Box display="flex" alignItems="center">
                    <Typography variant="h6">
                      Customer Ship To Code:{" "}
                    </Typography>
                    <Typography>{catalogData.customerShipToCode}</Typography>
                  </Box>
                  <Box mb={2} />
                  <Box display="flex" alignItems="center">
                    <Typography variant="h6">My Ship To Code: </Typography>
                    <Typography>{catalogData.myShipToCode}</Typography>
                  </Box>
                  <Box mb={2} />
                  <Box display="flex" alignItems="center">
                    <Typography variant="h6">Customer Carrier: </Typography>
                    <Typography>{catalogData.theirCarrier}</Typography>
                  </Box>
                  <Box mb={2} />
                  <Box display="flex" alignItems="center">
                    <Typography variant="h6">My Carrier: </Typography>
                    <Typography>{catalogData.myCarrier}</Typography>
                  </Box>
                  <Box mb={2} />
                  <Typography variant="h6">Customer Item Code(s):</Typography>
                  {catalogData.customerItemCodes.map((code, index) => (
                    <Typography key={index}>{code}</Typography>
                  ))}
                  <Box mb={2} />
                  <Typography variant="h6">My Item Code(s):</Typography>
                  {catalogData.myItemCodes.map((code, index) => (
                    <Typography key={index}>{code}</Typography>
                  ))}
                </Box>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <ShepButton
          onClick={handleCloseViewDataPopup}
          variant="primary"
          className="right-aligned-button"
        >
          Close
        </ShepButton>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDataPopup;
